import moment from "moment";

import { FlightStream } from "../../gol-api/types/flightSearch";
import { dateComparator, formatCZDayMonth } from "../../lib/datetime";
import { groupBy } from "../../lib/functions";

export function getMarketingAirlinesFromFlightSegments(
  flightSegments
): string[] {
  const allMarketingAirlinesInStream: Set<string> = new Set(
    flightSegments.map((flightSegment) => flightSegment.MarketingAirline)
  );
  return [...allMarketingAirlinesInStream];
}

export function getFlightStreamData({
  options,
  flightStream,
  selectedOptionKey,
}) {
  const flightOptions = options
    ? flightStream.filter((fs) => options.includes(fs.Key))
    : flightStream; // if used from result detail, there is only one flightStream
  const optionsByDate = groupBy(
    (fo) => formatCZDayMonth(moment(fo.DepartureDateTime)),
    flightOptions
  );
  const selectedFlightStream =
    (selectedOptionKey &&
      flightOptions.find((fo) => fo.Key === selectedOptionKey)) ||
    flightOptions[0];

  const selectedDate = formatCZDayMonth(
    moment(selectedFlightStream.DepartureDateTime)
  );

  const timesForSelection = optionsByDate[selectedDate].sort((fs1, fs2) =>
    dateComparator(fs1.DepartureDateTime, fs2.DepartureDateTime)
  );

  const isMultipleStreamOptions = timesForSelection.length > 1;
  const dateDeparture = selectedFlightStream.DepartureDateTime;
  const dateArrival = selectedFlightStream.ArrivalDateTime;
  const firstSegment = selectedFlightStream.FlightSegments.FlightSegment[0];
  const lastSegment =
    selectedFlightStream.FlightSegments.FlightSegment[
      selectedFlightStream.FlightSegments.FlightSegment.length - 1
    ];

  if (selectedFlightStream.numTransfers === undefined) {
    selectedFlightStream.numTransfers =
      selectedFlightStream?.FlightSegments?.FlightSegment?.length - 1 || 0;
  }

  return {
    optionsByDate,
    selectedFlightStream,
    selectedDate,
    timesForSelection,
    isMultipleStreamOptions,
    dateDeparture,
    dateArrival,
    firstSegment,
    lastSegment,
  };
}

export type OptionsByDate =
  | {
      string: FlightStream[];
    }
  | any;

export function getOptionDates(optionsByDate: OptionsByDate = {}): string[] {
  return Object.entries(optionsByDate)
    .sort((a, b) => {
      const fs1 = a[1][0];
      const fs2 = b[1][0];
      return dateComparator(fs1.DepartureDateTime, fs2.DepartureDateTime);
    })
    .map(([date]) => date);
}
